import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { toast } from "@devhop/ui";
import { useSettingsQuery, useUpdateSettings } from "../api/queries";
import { SettingsForm } from "../ui/SettingsForm";

export function SettingsPage() {
  const { data: settings, ...queryResult } = useSettingsQuery();
  const updateSettings = useUpdateSettings();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຕັ້ງຄ່າ" },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-6">
          <h1 className="font-bold text-2xl tracking-tight">ຕັ້ງຄ່າທົ່ວໄປ</h1>
          <p className="mt-1 text-muted-foreground text-sm">
            ຕັ້ງຄ່າ SEO ທົ່ວໂລກ ແລະ ວິທີການຊຳລະ
          </p>
        </div>
        <QueryState
          result={queryResult}
          title="ກຳລັງໂຫຼດຕັ້ງຄ່າ"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!settings ? null : (
            <SettingsForm
              initialValues={settings}
              onSubmit={async (input) => {
                await updateSettings.mutateAsync(input);
                toast.success("ບັນທຶກຕັ້ງຄ່າສຳເລັດ");
              }}
              submitting={updateSettings.isPending}
            />
          )}
        </QueryState>
      </Main>
    </>
  );
}
